import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getK3Docs, setK3Docs } from '../../actions';
import {
  Button,
  Card,
  Form,
  InputGroup,
  Row,
  Col,
  Badge,
  Spinner
} from 'react-bootstrap';
import { BsSearch, BsPlus, BsFilter, BsFiles, BsCode, BsTrash } from 'react-icons/bs';
import K3DocCreator from './K3DocCreator';
import K3DocView from './K3DocView';
import K3ModalViewSource from '../../components/K3/K3ModalViewSource';

class K3DocList extends Component {
  constructor(props) {
    super();
    const savedFilters = JSON.parse(localStorage.getItem('k3DocListFilters')) || {
      showCommitData: true,
      showAgentData: true
    };
    this.state = {
      aiConversations: [],
      isLoading: true,
      showCreator: false,
      showViewer: false,
      selectedDoc: null,
      sortField: 'create_time',
      sortDirection: 'desc',
      selectedConversations: new Set(),
      filters: {
        type: ''
      },
      showCommitData: savedFilters.showCommitData,
      showAgentData: savedFilters.showAgentData
    };
  }

  componentDidMount() {
    this.props.getK3Docs();
  }

  handleSearch = (e) => {
    e.preventDefault();
    const { searchKeyword, filters } = this.state;
    const query = {
      keyword: searchKeyword.trim(),
      ...filters
    };
    this.props.getK3Docs(query);
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        [name]: value
      }
    }), () => {
      const { searchKeyword, filters } = this.state;
      this.props.getK3Docs({ keyword: searchKeyword.trim(), ...filters });
    });
  };

  handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked }, () => {
      // Save to localStorage
      localStorage.setItem('k3DocListFilters', JSON.stringify({
        showCommitData: this.state.showCommitData,
        showAgentData: this.state.showAgentData
      }));
    });
  };

  filterDocs = (docs) => {
    const { showCommitData, showAgentData } = this.state;
    return docs.filter(doc => {
      if (!showCommitData && (doc.type === 'main_message' || doc.type === 'sub_message')) {
        return false;
      }
      if (!showAgentData && doc.type === 'agent_data') {
        return false;
      }
      return true;
    });
  };

  handleViewDoc = (doc) => {
    this.setState({
      selectedDoc: doc,
      showViewer: true
    });
  };

  handleCopyDoc = async (doc) => {
    try {
      // Extract number from title if exists
      const titleMatch = doc.title.match(/^(.*?)\s*\((\d+)\)$/);
      let newTitle;
      if (titleMatch) {
        const baseTitle = titleMatch[1];
        const number = parseInt(titleMatch[2]) + 1;
        newTitle = `${baseTitle} (${number})`;
      } else {
        newTitle = `${doc.title} (2)`;
      }

      // Create new doc object
      const newDoc = {
        ...doc,
        title: newTitle,
        friendly_version: ''
      };

      // Remove fields that should not be copied
      delete newDoc._id;
      delete newDoc.createdAt;
      delete newDoc.updatedAt;

      await this.props.setK3Docs([newDoc], { generate_version: true });
      this.props.getK3Docs();
    } catch (error) {
      console.error('Error copying document:', error);
    }
  };

  handleShowSource = (doc) => {
    this.setState({
      selectedDocForSource: doc,
      showSourceModal: true
    });
  };

  handleHideSource = () => {
    this.setState({
      selectedDocForSource: null,
      showSourceModal: false
    });
  };

  handleDeleteDoc = async (doc) => {
    if (window.confirm(`Are you sure you want to delete document "${doc.title}"?`)) {
      try {
        await this.props.setK3Docs([{
          _id: doc._id,
          is_deleted: true
        }]);
        this.props.getK3Docs();
      } catch (error) {
        console.error('Error deleting document:', error);
      }
    }
  };

  render() {
    const { docs, loading } = this.props;
    const {
      searchKeyword,
      showCreator,
      showViewer,
      selectedDoc,
      filters,
      showSourceModal,
      selectedDocForSource,
      showCommitData,
      showAgentData
    } = this.state;

    const filteredDocs = this.filterDocs(docs);

    return (
      <div className="container-fluid p-4">
        <Row className="mb-4 align-items-center">
          <Col md={8}>
            <Form onSubmit={this.handleSearch}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search documents..."
                  value={searchKeyword}
                  onChange={(e) => this.setState({ searchKeyword: e.target.value })}
                />
                <Button variant="outline-secondary" type="submit">
                  <BsSearch />
                </Button>
              </InputGroup>
            </Form>
          </Col>
          <Col md={4} className="text-end">
            <Button
              variant="primary"
              onClick={() => this.setState({ showCreator: true })}
            >
              <BsPlus className="me-1" /> New Document
            </Button>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <div className="d-flex align-items-center gap-4">
              <Form.Select
                name="type"
                value={filters.type}
                onChange={this.handleFilterChange}
                className="w-auto"
              >
                <option value="">All Types</option>
                <option value="k3_document">K3 Document</option>
                <option value="main_message">Commit Main Message</option>
                <option value="sub_message">Commit Sub Message</option>
                <option value="system_prompt">System Prompt</option>
                <option value="agent_prompt">Agent Prompt</option>
                <option value="agent_data">Agent Data</option>
                <option value="other">Other</option>
              </Form.Select>

              <Form.Check
                type="checkbox"
                id="showCommitData"
                name="showCommitData"
                label="Show Commit Data"
                checked={showCommitData}
                onChange={this.handleCheckboxChange}
                className="mb-0"
              />

              <Form.Check
                type="checkbox"
                id="showAgentData"
                name="showAgentData"
                label="Show Agent Data"
                checked={showAgentData}
                onChange={this.handleCheckboxChange}
                className="mb-0"
              />
            </div>
          </Col>
        </Row>

        {loading ? (
          <div className="text-center p-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <Row>
            {filteredDocs.map(doc => (
              <Col key={doc._id} lg={3} md={4} sm={6} className="mb-4">
                <Card className="h-100 shadow-sm">
                  <Card.Body>
                    <Card.Title 
                      className="text-truncate mb-2" 
                      title={`${doc.title}\n\n${doc.description || ''}`}
                    >
                      <h5>{doc.title}</h5>
                    </Card.Title>
                    <div className="small text-muted mb-2">
                      <div>MID: {doc.doc_mid}</div>
                      <div>Type: {doc.type}</div>
                      <div>Status: {doc.status}</div>
                      <div>Version: {doc.friendly_version || doc.version}</div>
                    </div>
                    <div className="mb-3" style={{ minHeight: '24px' }}>
                      {doc.tags?.map(tag => (
                        <Badge pill key={tag} bg="success" className="me-1 mb-1">
                          {tag}
                        </Badge>
                      ))}
                    </div>
                    <div className="d-flex justify-content-center gap-2">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="w-auto"
                        onClick={() => this.handleViewDoc(doc)}
                      >
                        View
                      </Button>
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        className="w-auto"
                        onClick={() => this.handleCopyDoc(doc)}
                      >
                        <BsFiles className="me-1" /> Clone
                      </Button>
                      <Button
                        variant="outline-dark"
                        size="sm"
                        className="w-auto"
                        onClick={() => this.handleShowSource(doc)}
                      >
                        <BsCode className="me-1" /> Source
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        className="w-auto"
                        onClick={() => this.handleDeleteDoc(doc)}
                      >
                        <BsTrash className="me-1" /> Delete
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}

        {showCreator && (
          <K3DocCreator
            show={showCreator}
            onHide={() => this.setState({ showCreator: false })}
          />
        )}

        {showViewer && selectedDoc && (
          <K3DocView
            show={showViewer}
            onHide={() => this.setState({ showViewer: false, selectedDoc: null })}
            selectedDoc={selectedDoc}
          />
        )}

        <K3ModalViewSource
          show={showSourceModal}
          onHide={this.handleHideSource}
          data={selectedDocForSource}
          title="Document Source"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  docs: state.k3docReducer.docs,
  loading: state.k3docReducer.loading
});

export default connect(mapStateToProps, { getK3Docs, setK3Docs })(K3DocList); 